import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import _ from "lodash";
import {Typography} from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import MomentsPlaylistSearch from "./MomentsPlaylistSearch";
import {withSnackbar} from "notistack";
import CollectionMomentPlaylists from "./CollectionMomentPlaylists";
import showSnackBar from "../Utilities/SnackbarHelper";
import MomentService from "../Services/MomentsService";
import {addToList, handleReOrder} from "../Utilities/List";
import ReactGA from 'react-ga';
import {ERROR, SUCCESS, WARNING} from "../constants";
import DragHandle from "@material-ui/icons/DragHandle";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import {MOMENTS_COLLECTIONS, REORDER_MOMENT_PLAYLIST, SAVE_COLLECTION,
    SEARCH_COLLECTION_MOMENT_CLIP_ID, SEARCH_COLLECTION_MOMENT_CLIP_TITLE ,
    DELETE_PLAYLIST_FROM_COLLECTION } from '../Utilities/GAUtils';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },

    formControl: {},
    titleInput: {},
    tagsInput: {},
    addPlaylistContainer: {
        marginTop: theme.spacing(3)
    },
    timeInput: {},
    button: {
        marginTop: theme.spacing(3),
    },
    expansionPanelDetailsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    momentIdInput: {
        marginTop: "-13px"
    },
    handler: {},
    dragDropIcon: {}

});


class CollectionInput extends Component {

    constructor(props) {
        super(props);

        let expanded = false;
        if (!props.collection.id) {
            expanded = true
        }

        this.state = {
            id: props.collection.id || null,
            title: props.collection.title,
            position: props.collection.position,
            contents: props.collection.contents,
            region: props.collection.region,
            subRegion: props.collection.subRegion,
            product: props.collection.product,
            momentsPlaylistId: '',
            tags: props.collection.tags,
            expanded: expanded,
            inputSearchText: ''
        }


    }

    handleChange = name => event => {
        this.setState({[name]: event.target.value});
    };

    onBlurSearchByCIDGoogleAnalytics = (event) => {
        ReactGA.ga('send','event',
                MOMENTS_COLLECTIONS,
                SEARCH_COLLECTION_MOMENT_CLIP_ID,
                event.target.value,
                1)
    }

    handleExpand = name => (event, isExpanded) => {
        console.log({isExpanded});
        this.setState({expanded: !this.state.expanded});
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({contents: nextProps.collection.contents})
    }

    handleSuggestionSelect(momentsPlaylistId, content) {
        let self = this;

        let contents = this.state.contents;

        let newContents = [];

        let contentToCheck = content;
        contentToCheck.contentId = content.id;
        newContents = addToList(contentToCheck, contents, self, 'contentId');
        newContents = this.addContentType(newContents, content);
        self.setState({contents: newContents});
        ReactGA.ga('send','event',
                MOMENTS_COLLECTIONS,
                SEARCH_COLLECTION_MOMENT_CLIP_TITLE,
                content.title,
                1)
    }

    addContentType(newContents, content) {
        newContents = newContents.map((newContent) => {
            if (newContent.id) {
                if (newContent.id === content.id) {
                    delete newContent.id;
                    newContent.contentType = "MOMENTS";
                    return newContent;
                } else {
                    return newContent
                }
            } else {
                return newContent
            }

        });
        return newContents;
    }

    removeMomentPlaylist(momentPlaylistId, recordId) {

        let contents = this.state.contents;

        let self = this;

        let momentsCollectionRecord = {
            "momentsCollectionId": this.state.id,
            "contentId": momentPlaylistId,
            "contentType": "MOMENTS"
        };

        MomentService.removeMomentsPlaylistFromCollection(momentsCollectionRecord).then((response) => {
            if (response.data.responseType === "SUCCESS") {
                showSnackBar("Moments playlist removed successfully!", SUCCESS, self);
                self.props.loadCollections();

            } else {
                let errorMessages = "";
                if (response.data.genericMessage && response.data.genericMessage.ERROR) {
                    errorMessages = errorMessages + response.data.genericMessage.ERROR.join(". ");
                }
                showSnackBar(`Moments playlist can not be removed. ${errorMessages}`, ERROR, self);
            }
        });
        ReactGA.ga('send','event',
                MOMENTS_COLLECTIONS,
                DELETE_PLAYLIST_FROM_COLLECTION,
                this.state.id,
                1)
    }

    saveCollection(event) {

        let self = this;
        if (event) {
            event.preventDefault();
        }
        let contents = this.state.contents;
        contents = _.map(contents, (content) => {
            delete content.thumbnails;
            delete content.momentClips;
            return content;
        });

        let collectionToSave = [{
            id: this.state.id,
            title: this.state.title,
            contents: contents,
            region: this.state.region,
            subRegion: this.state.subRegion,
            product: this.state.product,
            position: this.state.position,
            tags: this.state.tags,
            active: true
        }];

        console.log({collectionToSave});

        let momentsServiceToUse = null;
        if (collectionToSave[0].id) {
            momentsServiceToUse = MomentService.saveMomentsCollection(collectionToSave);
        } else {
            delete collectionToSave[0].id;
            momentsServiceToUse = MomentService.createMomentsCollection(collectionToSave);
        }
        momentsServiceToUse.then((response) => {
            if (response.data.responseType === "SUCCESS") {

                self.props.loadCollections();

                if (response.data.genericMessage && response.data.genericMessage.SUCCESS && response.data.genericMessage.SUCCESS.length > 0) {
                    let cidsList = response.data.genericMessage.SUCCESS;
                    let warningMessage = `Moments collection saved with moments having CIDs with NO VIU RIGHTS for this region - ${cidsList.join()}`;
                    showSnackBar(warningMessage, WARNING, self);

                } else {
                    showSnackBar("Moments collection saved successfully!", SUCCESS, self);
                }
            } else {
                let errorMessages = "";
                if (response.data.genericMessage && response.data.genericMessage.ERROR) {
                    errorMessages = errorMessages + response.data.genericMessage.ERROR.join(". ");
                }
                showSnackBar(`Moments collection can not be saved. ${errorMessages}`, ERROR, self);
            }
        });

        ReactGA.ga('send','event',
                MOMENTS_COLLECTIONS,
                SAVE_COLLECTION,
                this.state.id,
                1)
    }

    onDragDropPosition(event) {
        let momentsPlaylistOrderedIDs = event;
        let contents = this.state.contents;
        let newContents = handleReOrder(momentsPlaylistOrderedIDs, contents, 'contentId');
        this.setState({contents: newContents});
        ReactGA.ga('send','event',
                MOMENTS_COLLECTIONS,
                REORDER_MOMENT_PLAYLIST,
                this.state.id,
                1)
    }


    handleAddMomentsPlaylistById(event) {


        if (event.key === 'Enter') {
            event.preventDefault();
            let momentsPlaylistId = event.target.value;
            this.setState({inputSearchText: 'toClearInputSearchText'});
            let newContents = [];
            let contents = this.state.contents;
            let self = this;
            if (momentsPlaylistId) {
                MomentService.getMomentsPlaylist(momentsPlaylistId).then((response) => {
                    let content = response.data.entity;
                    if (content) {
                        let contentToCheck = content;
                        contentToCheck.contentId = content.id;
                        newContents = addToList(contentToCheck, contents, self, 'contentId');
                        newContents = this.addContentType(newContents, content);
                        self.setState({contents: newContents});
                    } else {
                        showSnackBar("Invalid moments playlist ID.", ERROR, self);
                        console.log(response);
                    }

                })
            }
        }

    }

    render() {

        const {classes, theme} = this.props;
        return (

            <React.Fragment>
                <form onSubmit={this.saveCollection.bind(this)}>
                    <ExpansionPanel expanded={this.state.expanded} onChange={this.handleExpand('expanded')}
                                    defaultExpanded={'false'}>

                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >

                            <Grid container
                                  direction="row"
                                  justify="center"
                                  alignItems="center" spacing={0}>

                                <Grid item xs={1}>
                                    {this.state.id && this.state.id !== null &&
                                    <Typography variant={"body2"}>ID : {this.state.id}</Typography>
                                    }
                                </Grid>

                                <Grid item xs={6}>

                                    {(this.state.id !== null) && this.state.title &&
                                    <Typography variant={'body2'}>  {this.state.title}</Typography>
                                    }
                                    {!this.state.id && !this.state.title &&
                                    <Typography variant={'body2'}> Create New Collection</Typography>
                                    }
                                    {(this.state.id === null) && (this.state.title) &&
                                    <Typography variant={'body2'}> Create New Collection with
                                        title {this.state.title}</Typography>
                                    }


                                </Grid>

                                <Grid item xs={2}>

                                </Grid>

                                <Grid item xs={2}>
                                    <Typography variant={"body2"}>Position : {this.state.position}</Typography>
                                </Grid>

                                <Grid item xs={1}>


                                    <Tooltip title="Drag this to reorder" aria-label="Drag this to reorder">
                                        <IconButton onClick={(event) => {
                                            event.preventDefault()
                                        }} class={'handler MuiButtonBase-root MuiIconButton-root'}>

                                            <DragHandle fontSize={"small"} className={classes.dragDropIcon}/>

                                        </IconButton>

                                    </Tooltip>
                                </Grid>

                            </Grid>


                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expansionPanelDetailsContainer}>


                            <Grid container
                                  direction="row"
                                  justify="center"
                                  alignItems="center" spacing={0}>
                                <Grid item xs={3}></Grid>
                                <Grid item xs={6}>

                                    <TextField fullWidth
                                               id="title" required
                                               label="Moments Collection Title"
                                               className={classes.titleInput}
                                               onChange={this.handleChange('title')}
                                               value={this.state.title}
                                               margin="normal"
                                    />
                                    <TextField fullWidth
                                               id="tags"
                                               label="Tags"
                                               className={classes.tagsInput}
                                               onChange={this.handleChange('tags')}
                                               value={this.state.tags}
                                               margin="normal"
                                    />


                                </Grid>
                                <Grid item xs={3}></Grid>
                            </Grid>

                            <Grid container className={classes.addPlaylistContainer}
                                  direction="row"
                                  justify="center"
                                  alignItems="center" spacing={0}>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={6}>
                                    <Typography variant={"body1"}>Add Moments Playlist</Typography>
                                    <Grid container>
                                        <Grid item xs={7}>
                                            <MomentsPlaylistSearch inputSearchText={this.state.inputSearchText}
                                                                   handleSuggestionSelect={this.handleSuggestionSelect.bind(this)}/>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <Typography variant={"body2"}>
                                                OR
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField onKeyDown={this.handleAddMomentsPlaylistById.bind(this)}
                                                       id="momentId"
                                                       className={classes.momentIdInput}
                                                       label="Moments Playlist ID"
                                                       value={this.state.momentsPlaylistId}
                                                       onChange={this.handleChange('momentsPlaylistId')}
                                                       onBlur = {this.onBlurSearchByCIDGoogleAnalytics}
                                                       placeholder={"e.g. 42"}
                                                       margin="normal"
                                            />
                                        </Grid>


                                    </Grid>

                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>

                                    <CollectionMomentPlaylists contents={this.state.contents}
                                                               removeMomentPlaylist={this.removeMomentPlaylist.bind(this)}
                                                               onChange={this.onDragDropPosition.bind(this)}/>

                                    <br/>
                                </Grid>
                                <Grid item xs={2}></Grid>
                            </Grid>

                            <Grid container spacing={0}>
                                <Grid item xs={5}></Grid>
                                <Grid item xs={2}>
                                    <Button variant={"contained"} type={'submit'} color={"primary"}>Save
                                        Collection</Button>
                                </Grid>
                                <Grid item xs={3}></Grid>
                                <Grid item xs={2}>
                                    <Button variant={"contained"} type={'button'}
                                            onClick={this.props.deleteCollection.bind(this, this.state.id)}
                                            color={"secondary"}>Delete</Button>
                                </Grid>
                            </Grid>

                        </ExpansionPanelDetails>

                    </ExpansionPanel>
                </form>
                <br/>
            </React.Fragment>


        );
    }

}


export default (withStyles(styles, {withTheme: true})(withSnackbar(CollectionInput)));